import * as React from 'react';
import { SVGProps } from 'react';

const IconIntroductionSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M22 2h-2v20h2V2zM8.59 5.41 10 4l8 8-8 8-1.41-1.41L14.17 13H2v-2h12.17L8.59 5.41z" />
  </svg>
);
export default IconIntroductionSizeM;
